import { QuantityCode, system as quroSystem } from '../coding';

export interface QuantityParams {
  value: number;
  code: QuantityCode;
  unit?: string;
  system?: string;
}

/**
 * Create an oxygen rate with the default unit, assuming the value is greater than 0
 */
export const createValidOxygenRate = (
  value?: number,
): fhir4.Quantity | undefined => {
  const hasValue = !!value;

  const isPositive = hasValue && value > 0;

  if (!isPositive) {
    return undefined;
  }

  return createQuantityWithValue({
    value,
    code: QuantityCode.OxygenRate,
    unit: 'L/min',
  });
};

interface QuantityWithValue extends fhir4.Quantity {
  value: number;
}

export const hasQuantityValue = (
  quantity?: fhir4.Quantity,
): quantity is QuantityWithValue => typeof quantity?.value === 'number';

/**
 * if the quantity value is defined then it will return the quantity otherwise return undefined
 */
export const getQuantityWithValue = (
  quantity?: fhir4.Quantity,
): QuantityWithValue | undefined => {
  if (!hasQuantityValue(quantity)) {
    return undefined;
  }

  return quantity;
};

export const createQuantityWithValue = (
  params: QuantityParams,
): QuantityWithValue => {
  const { value, unit, code, system = quroSystem } = params;

  const quantity: QuantityWithValue = {
    value,
    code,
    system,
  };

  return unit ? { ...quantity, unit } : quantity;
};
